/**
 *
 * Asynchronously loads the component for CandidateAcceptProfilerInvite
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/CandidateAcceptProfilerInvite/loadable.js